import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Badge, Container, List } from '@pella/sash-framework';
import { isValidArray } from '../../../utilities/validations';

import ProjectGalleryGrid from '../project-gallery-grid';

import './index.css';

const ProjectGallery = ({ data, projects, className }) => {
	const [activeFilter, setActiveFilter] = useState({ name: data?.filter_tag?.[0]?.display_name, tag: data?.filter_tag?.[0]?.filter_tags?.[0] });
	const [filteredProjects, setFilteredProjects] = useState(projects);
	const [projectsToShow, setProjectsToShow] = useState(6);

	if (!isValidArray(projects) || !data) return null;

	const onFilterClick = (name, tag) => {
		let filterProjectsByTag = [];

		if (tag) {
			filterProjectsByTag = projects.filter((project) => project.taxonomies?.map((taxonomy) => taxonomy.term_uid)?.includes(tag));
		}

		setActiveFilter({ name: name, tag: tag });
		setFilteredProjects(tag ? filterProjectsByTag : projects);
	};

	const onLoadMoreClick = () => setProjectsToShow(projectsToShow + 6);

	return (
		<div
			data-testid='project-gallery'
			className={`py-8 xl:py-[42px] ${className || ''}`}
		>
			<Container className='relative'>
				{data.heading && <h2 className='m-0'>{data.heading}</h2>}

				{isValidArray(data.filter_tag) && (
					<List
						bullets='none'
						className='projectFilterList my-6 flex snap-x snap-mandatory flex-nowrap gap-x-2 overflow-x-auto'
					>
						{data.filter_tag.map((tag, index) => (
							<li
								key={`filter-${index}`}
								className='flex-none snap-start'
							>
								<button onClick={() => onFilterClick(tag.display_name, tag.filter_tags?.[0])}>
									<Badge
										size='md'
										color='light-gray'
										className={`!px-4 !py-2 ${activeFilter?.name === tag.display_name ? 'border-black' : 'border-transparent hover:bg-gray-10'}`}
										variant='rounded'
									>
										{tag.display_name}
									</Badge>
								</button>
							</li>
						))}
					</List>
				)}

				<ProjectGalleryGrid
					key={projectsToShow}
					projects={filteredProjects}
					projectsToShow={projectsToShow}
					onLoadMoreClick={onLoadMoreClick}
				/>
			</Container>
		</div>
	);
};

ProjectGallery.propTypes = {
	projects: PropTypes.array,
	className: PropTypes.string,
	data: PropTypes.object,
};

export default ProjectGallery;
